import "react-datepicker/dist/react-datepicker.css";
import "./assets/css/main.css";
import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { ErrorBoundary } from "react-error-boundary";
import ErrorImage from "./assets/images/500.webp";

function FallbackErrorBoundary({ error }) {
  return (
    <div className="min-h-screen w-full bg-white grid place-items-center gap-2 pb-10">
      <img
        src={ErrorImage}
        alt="Error Image"
        className="w-3/4 h-[450px] mx-auto"
      />
      <h4 className="text-red-400 text-lg font-semibold italic">
        Error: {error?.message || "Maaf terjadi kesalahan internal"}
      </h4>
      <button
        type="button"
        onClick={() => (window.location.href = "/")}
        className="bg-red-400 text-white px-5 py-3 rounded-md active:bg-red-500"
      >
        Kembali ke Halaman Utama
      </button>
    </div>
  );
}
createRoot(document.getElementById("root")).render(
  <ErrorBoundary
    fallbackRender={FallbackErrorBoundary}
    onError={(err) => console.log({ errBoundary: err })}
  >
    <App />
  </ErrorBoundary>
);
